import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DfxParams } from '../models/dfx-params.model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(
    private http: HttpClient
  ) { }

  getLogo(): Observable<Blob> {
    return this.http.get('/api/logo', { responseType: 'blob' });
  }

  setLogo(file: any) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post('/api/logo', formData, { responseType: 'blob' });
  }

  deleteLogo() {
    return this.http.delete('/api/logo');
  }

  getDfxTemplate(): Observable<Blob> {
    return this.http.get('/api/dxf_template', { responseType: 'blob' });
  }

  setDfxTemplate(file: any) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post('/api/dxf_template', formData);
  }

  deleteDfxTemplate() {
    return this.http.delete('/api/dxf_template');
  }

  getDfxParams(): Observable<DfxParams> {
    return this.http.get<DfxParams>('/api/dxf_params');
  }

  setDfxParams(params: DfxParams) {
    return this.http.post<DfxParams>('/api/dxf_params', params);
  }


}
